/**
 * Created by matheusmorett on 23/08/18.
 */
import React, {Component} from 'react';

import './Grid.scss';

export default class Grid extends Component {

    static defaultProps = {
        className: "",
        onClick: () => {},
        setRef: () => {}
    };

    render() {
        return (
            <div className={"Grid2 " + this.props.className} onClick={() => this.props.onClick()} ref={(el) => this.props.setRef(el)} >
                {this.props.children}
            </div>
        )
    }

}

